/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-join[_ngcontent-%COMP%]{width:100%;padding:.75rem;background:#ff6000;color:#fff;border:none;border-radius:8px;font-weight:700;font-size:1rem;cursor:pointer;transition:background .2s}.btn-join[_ngcontent-%COMP%]:hover{background:#cc4d00}.countdown-timer[_ngcontent-%COMP%], .date[_ngcontent-%COMP%], .time[_ngcontent-%COMP%]{text-align:center;font-size:1rem;color:#404040}.date[_ngcontent-%COMP%]{font-family:PoppinsSemiBold}.action-container[_ngcontent-%COMP%]{padding:1rem;border:1px solid #cad1d9;border-radius:8px}.error-message[_ngcontent-%COMP%]{color:#fb4a4a;text-align:center;font-size:.875rem}"];
export { styles as styles };
//# sourceMappingURL=cohort-tile-join.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/cohort/cohort-tile/cohort-tile-join/cohort-tile-join.component.scss.shim.ngstyle.js
// module id = 1485
// module chunks = 27 28 29